var map = {
	"./destination_reached.svg": 148,
	"./floor_switcher.svg": 149,
	"./sharp_left.svg": 150,
	"./sharp_right.svg": 151,
	"./slight_left.svg": 152,
	"./slight_right.svg": 153,
	"./straigt.svg": 154,
	"./turn_left.svg": 155,
	"./turn_right.svg": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;